import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isEqual, difference } from 'lodash'
import { compose, lifecycle, shouldUpdate, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'
import { IntlProvider } from 'react-intl-redux'

import Person from './../../components/Person'
import Loader from './../../components/OverlayLoader'

import { fetchingState } from '../../helpers/hocs.js'
import { getLotsForIndex, getCountForIndex } from '../../selectors/lots.js'
import { getList, getCount, clearKeys } from '../../store/reducers/lots/list.js'

import { sendViewLotsList } from '../../helpers/tagManager'

const LotsList = ({ items = {}, keys = [], title, expandable = false, isSpecial = false, fetching = false, count = 0, loadMore, containerClass = '', className = 'Persons__section', listName, }) => {
  if (!fetching && !keys.length) return <div style={{textAlign: 'center'}}>Идет загрузка, пожалуйста, подождите</div>
  if (fetching && !keys.length) return <div><FormattedMessage id='lot_list_index.loading' /></div>

  const moreBtn = expandable // && (count > keys.length)

  return (
    <section className={className}>

      {title && <h1 className='SubHead Persons__title'>{title}</h1>}

      <Loader loading={fetching}>
        <div className={containerClass}>
          {keys.map((key, index) => <Person key={`${key}`} data={items[key]} isSpecial={isSpecial} position={index + 1} listName={listName}/>)}
        </div>
      </Loader>

      { moreBtn && (
        <div className='Persons__more'>
          <button className='Button Button_black' onClick={loadMore}>
            <IntlProvider>
              <FormattedMessage id='lot_list_index.more' />
            </IntlProvider>
          </button>
        </div>
      )}
    </section>
  )
}

const mapStateToProps = () => {
  const getLots = getLotsForIndex()
  const getCount = getCountForIndex()

  return (state, props) => ({
    ...getLots(state, props),
    count: getCount(state, props)
  })
}

const mapDIspatchToProps = dispatch => bindActionCreators({ getList, getCount, clearKeys }, dispatch)
//typelot параметр передаваемый для определения типа лотов, для составления пути перехода
const mergeProps = (state, { getList, getCount, clearKeys }, {typelot = 'all', limit = 3, type, project, ...props }) => {
  const getLots = (params = {}, noLoader = false) => {
    params = { ...params, limit, typelot, project, offset: params.rewrite ? 0 : state.keys.length }
    delete params.rewrite
    return noLoader ? getList(type, params) : props.fetchingWrap(getList.bind(this, type, params))
  }
  const getLotsCount = (params = {}) => getCount(type, params)
  const clear = () => clearKeys(type)
  return { ...props, ...state, getLotsCount, getLots, clear }
}

export default compose(
  fetchingState(),
  connect(mapStateToProps, mapDIspatchToProps, mergeProps),
  shouldUpdate((props, np) => {
    const keysDiff = difference(np.keys || [], props.keys || []);
    //При изменении отображаемых лотов - отправляем статистику
    if (keysDiff.length > 0) {
      sendViewLotsList(keysDiff, np.keys, np.items, props.listName)
    }
    return (keysDiff.length > 0) || props.fetching !== np.fetching || !isEqual(np.params, props.params)
  }),
  lifecycle({
    componentWillMount () {
      this.props.getLots({ rewrite: true, ...this.props.params }, true)
      if (this.props.expandable) this.props.getLotsCount(this.props.params)
    },
    componentWillUnmount () {
      this.props.clear()
    },
    componentWillReceiveProps (np) {
      if (!isEqual(np.params, this.props.params)) {
        this.props.getLots({ ...np.params, rewrite: true })
        if (np.expandable) this.props.getLotsCount(np.params)
      }
    }
  }),
  withHandlers({
    loadMore: ({ params, getLots }) => e => getLots(params)
  })
)(LotsList)



// WEBPACK FOOTER //
// ./src/containers/LotList/index.jsx